import {
    type DigitallyReceivedPrescriberOrderInfoFragment,
    PrescriberOrderStatus,
    type UnclaimedPrescriberOrderInfoFragment,
} from '../../graphql/generated/graphql';
import { getAbsoluteRoute } from '../get-absolute-route';

export const getRedirectUrlByOrderStatus = (
    prescriberOrder:
        | DigitallyReceivedPrescriberOrderInfoFragment
        | UnclaimedPrescriberOrderInfoFragment
        | undefined
): string | null => {
    if (!prescriberOrder) {
        return getAbsoluteRoute('notFound');
    }

    if (prescriberOrder.__typename !== 'DigitallyReceivedPrescriberOrder') {
        return getAbsoluteRoute('order.prescriberOrderId.verifyPatient', {
            prescriberOrderId: prescriberOrder.drxId ?? '',
        });
    }

    if (
        prescriberOrder.status === PrescriberOrderStatus.SentToPharmacy ||
        prescriberOrder.status === PrescriberOrderStatus.Filled ||
        (prescriberOrder.status === PrescriberOrderStatus.Cancelled &&
            prescriberOrder.assignmentTimestamp)
    ) {
        return getAbsoluteRoute('order.prescriberOrderId.confirmation', {
            prescriberOrderId: prescriberOrder.drxId ?? '',
        });
    }

    if (prescriberOrder.status === PrescriberOrderStatus.Cancelled) {
        return getAbsoluteRoute('order.prescriberOrderId.summary', {
            prescriberOrderId: prescriberOrder.drxId ?? '',
        });
    }

    return null;
};
